
import React from 'react';

import './../Comp/Cards.css'


import { useEffect, useState } from 'react';




export const Cards = () => {


    const [loadingId, setLoadingId] = useState(null); // Store the ID of the currently loading request
  const [approved, setApproved] = useState({}); // Store approved statuses


    
    const token = localStorage.getItem('token')
    const fetchUsers = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);


      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: new FormData(),
        redirect: "follow",
      };

      try {
        const response = await fetch(
          "https://backend.booknxtcoin.com/api/admin/stakes",
          requestOptions
        );
        const result = await response.json();
        if (result.code === 200 && result.status === "success") {
          setUsers(result.data.data);
        } else {
          setError("Failed to fetch users");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    
    useEffect(() => {
        fetchUsers();
      }, []);

  const handleApprove = async (stakeId) => {
    const token = localStorage.getItem('token')

    setLoadingId(stakeId); // Start loader for this ID

    const myHeaders = new Headers();
    myHeaders.append(
      "Authorization", `Bearer ${token}`
    );

    const formdata = new FormData();
    formdata.append("stake_id", stakeId);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://backend.booknxtcoin.com/api/admin/stake/approve",
        requestOptions
      );

      const result = await response.text();
      console.log(result);
      setApproved((prev) => ({ ...prev, [stakeId]: true })); // Mark as approved
      fetchUsers()
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingId(null); // Stop loader
    }
  };


       const [users, setUsers] = useState([]);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
    
 
    
      if (loading) return <p>Loading...</p>;
      if (error) return <p>Error: {error}</p>;
  return (
    <>
   
        <div className="container mt-4">
      <h2 className="mb-3">Stake List</h2>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>Email</th>
            <th>Opening IP</th>
            <th>Closing</th>
            <th>Rate</th>
            <th style={{width:'100px'}}>Haskey</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th/>
          </tr>
        </thead>
        <tbody>

          {users.map((user) => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.user_id}</td>
              <td>{user.user_email}</td>
              <td>{user.opening || "N/A"}</td>
              <td>{user.closing}</td>
              <td>{user.rate}</td>
              <td style={{width:'100px'}}><p className='hashkey'>{user.hashkey}</p></td>
              <td>{user.status}</td>
              <td >{user.created_at}</td>
              <td>{user.updated_at}</td>
              <td>
  {user.status === "success" ? (
    <span style={{ color: "green", fontWeight: "bold" }}>✔️</span>
  ) : (
    !approved[user.id] && (
      <button
        onClick={() => handleApprove(user.id)}
        disabled={loadingId === user.id}
        className="approve_btn"
      >
        {loadingId === user.id ? "..." : "Approve"}
      </button>
    )
  )}
</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>

    </>
  )
}
 